import {
  Action,
  ActionStatus,
  ActionType,
  JourneyCollection,
} from 'interfaces/journey';

export interface RouteCollectionStats {
  total: number;
  collected: number;
  transferred: number;
  transferredTo: string[];
}

// Las colectas de esta ruta, también las que pasaron a otra sin visitarse: así el número coincide con
// la tabla. Las traídas de otra ruta no son de esta (son una entrega en el centro).
export const routeCollectionStats = (
  collections: JourneyCollection[],
  actions: Action[],
): RouteCollectionStats => {
  const collectBy = new Map<number, Action>();
  actions
    .filter((a) => a.collectionId && a.actionType === ActionType.Collect)
    .forEach((a) => collectBy.set(a.collectionId as number, a));
  const own = collections.filter((c) => !c.carriedFromJourneyId);
  const transferred = own
    .map((c) => collectBy.get(c.id))
    .filter((a): a is Action => a?.status === ActionStatus.Transferred);
  return {
    total: own.length,
    collected: own.filter(
      (c) => collectBy.get(c.id)?.status === ActionStatus.Completed,
    ).length,
    transferred: transferred.length,
    transferredTo: Array.from(
      new Set(transferred.map((a) => a.transferredTo).filter(Boolean)),
    ) as string[],
  };
};

// Paradas reales: un waypoint que solo tenía entregas en el centro queda sin acciones propias.
export const stopCount = (waypoints: { actions?: Action[] }[]): number =>
  waypoints.filter((wp) => (wp.actions?.length ?? 0) > 0).length;
